import { Flex, Text } from '@chakra-ui/react';
import Contact from './Contact';
import Testimonials from './Testimonials';

/**
 * Wrapper for the Contact and Testimonials sections
 * @returns The ContactTestimonials Component
 */
export default function ContactTestimonials() {

	return (
		<Flex
			id="testimonials"
			paddingTop="5%"
			backgroundColor={"black.200"}
			flexDirection={"column"}
		>
			<Text
				fontSize="4xl"
				fontFamily="Source Code Pro Variable"
				fontWeight="600"
				color="white.200"
				textAlign="center"
			>
				Testimonials
			</Text>

			<Flex
				flexDirection={{ base: "column", md: "row" }}
				minW={"100%"}
				maxW={"100%"}
				padding={{ base: "10px", md: "0px" }}
			>
				{/* Testimonials Section */}
				<Flex width={{ base: "100%", md: "55%"}}>
					<Testimonials />
				</Flex>

				{/* Contact Section */}
				<Flex width={{ base: "100%", md: "45%"}}>
					<Contact />
				</Flex>
			</Flex>
		</Flex>
	);
};
